import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import styles from './QuestionDisplay.scss';
import questionSelectionService from '../../services/QuestionSelectionService';

class QuestionManualSelection extends React.Component {
    static propTypes = {
        contentRevisionId: PropTypes.number.isRequired,
        isReadOnly: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        const { contentRevisionId } = this.props;
        this.state = {
            selectorValue: questionSelectionService.getSelectionForQuestion(contentRevisionId),
        };
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillReceiveProps(nextProps) {
        const selectionStateValue = questionSelectionService.getSelectionForQuestion(nextProps.contentRevisionId);
        if (selectionStateValue !== this.state.selectorValue) {
            this.setState({ selectorValue: selectionStateValue });
        }
    }

    handleSelection = () => {
        const { contentRevisionId } = this.props;
        const value = this.selectElem.value;
        this.setState({ selectorValue: value });
        questionSelectionService.handleSelection(contentRevisionId, value);
    };

    getStatusClass = () => {
        let classes = 'question';
        if (this.state.selectorValue === questionSelectionService.selectorOptions.YES) {
            classes = 'check';
        } else if (this.state.selectorValue === questionSelectionService.selectorOptions.NO) {
            classes = 'times warning';
        }

        return `${classes} status-icon`;
    };

    getSelectorValues = () => {
        const { contentRevisionId } = this.props;
        const values = Object.assign({}, questionSelectionService.selectorOptions);
        if (!questionSelectionService.isUndecided(contentRevisionId)) {
            delete values.UNDECIDED;
        }
        return values;
    };

    render() {
        const { isReadOnly, contentRevisionId } = this.props;
        const section = questionSelectionService.getSectionForQuestionId(contentRevisionId);
        const numberOfSelectedQuestions = questionSelectionService.getSectionSelectedQuestions(section).length;
        const maxSelectableQuestions = questionSelectionService.getNumberOfQuestionsToPullInSection(section);
        const options = Object.values(this.getSelectorValues()).map((value) => {
            return (<option key={value} value={value}>{t(`question.manualSelector.selectionType.${value}`)}</option>);
        });

        return (
            <div className={styles.questionPickWrapper}>
                <div className={styles.questionPickContent}>
                    <div className={styles.questionPickStatus}>
                        <p>{t('question.manualSelector.message')}</p>
                        <span>{numberOfSelectedQuestions}</span> {t('question.manualSelector.ofMaximum')} <span>{maxSelectableQuestions} </span>
                        {t('question.manualSelector.inThisSection')}
                    </div>

                    <div className={styles.questionPickSelectorWrapper}>
                        <select
                            className="questionPickSelector"
                            disabled={isReadOnly}
                            onChange={this.handleSelection}
                            ref={(el) => { this.selectElem = el; }}
                            value={this.state.selectorValue}
                        >
                            {options}
                        </select>
                        <i className={`fa fa-2x fa-${this.getStatusClass()}`} aria-hidden="true" />
                    </div>
                </div>
            </div>
        );
    }
}

export default QuestionManualSelection;
